var React = require('react');

function Sigma (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M7323365 6204498l240002-512248h205631l-346184 2076748H2231002v-401460l1793045-2115725-1793045-1793046V2231002h5300002l237994 1384499h-185789l-101339-210356c-190986-396854-334609-482012-751305-482012l-3580304 118 1909385 1909385-1608438 1897929h2933291c627407 0 793235-224766 938984-526067z"}));
}

Sigma.defaultProps = {"viewBox":"0 0 10000000 10000000"};

module.exports = Sigma;

Sigma.default = Sigma;
